import {
  Box,
  Modal,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { StyledButton } from 'UI/StyledButton';
import { useState } from "react";
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { styled } from '@mui/system';
import { addDocumentiOpzionali } from "services/addDocumentiOpzionali"
import { useMutation } from '@tanstack/react-query'
import CustomModal from 'UI/CustomModal'

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  width: 320px;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
`,
);

const DocumentiOpzionaliModal = ({ openModalDocumentiOpzionali, handleCloseModalDocumentiOpzionali, documentiOpzionaliInPratica, motivazioneRichiesteOpzionali, idPratica, refetchPraticheDettaglio }) => {
  const theme = useTheme()

  const documentiOpzionaliAll = JSON.parse(localStorage.getItem("DocumentiOpzionaliVari"));
  const [motivazione, setMotivazione] = useState(motivazioneRichiesteOpzionali)
  const [customModalProps, setCustomModalProps] = useState({ open: false, isLoading: false, isError: false, message: "" })

  const { open: openCustomModal, isLoading: isLoadingCustomModal, isError: isErrorCustomModal, message: messageCustomModal } = customModalProps;

  // INIZIO Parte APIs
  /*const mutationAddDocumentiOpzionali = useMutation({
    mutationFn: (body) => {
      return addDocumentiOpzionali(body)
    },
    onMutate: () => {
      setCustomModalProps(prevState => ({ ...prevState, open: true, isLoading: true }))
    },
    onSuccess: () => {
      setCustomModalProps(prevState => ({ ...prevState, message: "Richiesta documenti opzionali avvenuta con successo", isLoading: false }))
      refetchPraticheDettaglio();
      //window.location.reload()
    },
    onError: () => {
      setCustomModalProps(prevState => ({ ...prevState, message: "Richiesta documenti andata in errore", isError: true, isLoading: false }))
    },
    onSettled: () => {
      setTimeout(() => {
        setCustomModalProps({ open: false, message: "", isError: false, isLoading: false })
      }, "3000")
    }
  })*/
  const mutationAddDocumentiOpzionali = useMutation({

    mutationFn: async (body) => {
    debugger
      const response = await addDocumentiOpzionali(body);

      // Controlliamo esplicitamente che il codice nel body sia 200
      if (!response || response.data?.code !== 200) {
        throw new Error(response?.message || "Errore sconosciuto");
      }

      return response;
    },
    onMutate: () => {
      setCustomModalProps(prevState => ({ ...prevState, open: true, isLoading: true }))
    },
    onSuccess: (data) => {
      setCustomModalProps(prevState => ({
        ...prevState,
        message: data.message || "Richiesta documenti opzionali avvenuta con successo",
        isLoading: false
      }));
    },
    onError: (error) => {
      setCustomModalProps(prevState => ({
        ...prevState,
        message: error.message || "Richiesta documenti andata in errore",
        isError: true,
        isLoading: false
      }));
    },
    onSettled: () => {
      setTimeout(() => {
        setCustomModalProps({ open: false, message: "", isError: false, isLoading: false })
        handleCloseModalDocumentiOpzionali()
        refetchPraticheDettaglio();

      }, 3000);
    }
  });
  // FINE Parte APIs

  // INIZIO Parte funzioni
/*  const initializeDataForDocumentiOpzionali = (arrayDocumentiIniziali) => {
    let result = [];
    for (let i = 0; i < arrayDocumentiIniziali.length; i++) {
      let elementoToAdd = { nomeDocumento: arrayDocumentiIniziali[i], deletable: true, isChecked: false }
      for (let j = 0; j < documentiOpzionaliInPratica.length; j++) {
        const documentoOpzionaliInPratica = documentiOpzionaliInPratica[j];
        if (elementoToAdd.nomeDocumento === documentoOpzionaliInPratica.nome) {
          elementoToAdd = { ...elementoToAdd, deletable: documentoOpzionaliInPratica.deletable, isChecked: true }
          break;
        }
      }
      result.push(elementoToAdd);
    }
    return result;
  }*/
  const initializeDataForDocumentiOpzionali = (arrayDocumentiIniziali) => {
    return arrayDocumentiIniziali.map(nomeDocumento => {
      // Controllo se il documento è già stato selezionato
      const documentoSelezionato = documentiOpzionaliInPratica.find(d => d.nome === nomeDocumento);

      return {
        nomeDocumento,  // Ora è corretto, perché arrayDocumentiIniziali è una lista di stringhe
        deletable: documentoSelezionato ? documentoSelezionato.isDeletable : true, // Default: true se non è in documentiOpzionaliInPratica
        isChecked: !!documentoSelezionato // Se esiste in documentiOpzionaliInPratica, lo segno selezionato
      };
    });
  };
  // FINE Parte funzioni

  const [documentiOpzionali, setDocumentiOpzionali] = useState(initializeDataForDocumentiOpzionali(documentiOpzionaliAll))

  // INIZIO Parte handlers
  const handleCheck = (index) => {
    setDocumentiOpzionali(
      documentiOpzionali.map((documento, idx) => ({ ...documento, isChecked: index === idx ? !documento.isChecked : documento.isChecked }))
    )
  }

  const handleRichiesta = () => {
    const documentiSelezionati = documentiOpzionali.filter(doc => doc.isChecked).map(doc => doc.nomeDocumento)
    const bodyToSubmit = { motivazioneOpzionali: motivazione, documentiOpzionali: documentiSelezionati, idPratica }
    mutationAddDocumentiOpzionali.mutate(bodyToSubmit)
  }

  // FINE Parte handlers

  return <Modal
    hideBackdrop
    open={openModalDocumentiOpzionali}
    onClose={handleCloseModalDocumentiOpzionali}
    m
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: '550px',
      width: '900px',
      transform: 'translate(-50%, -50%)',
      maxWidth: '80vw',
      maxHeight: '80vh',
      overflowY: 'auto',
      border: '1px solid #000',
      boxShadow: 0,
      p: 2,
      backgroundColor: '#ffff',
      paddingTop: '0px',
    }}
  >
    <>
      <Box>
        <Stack direction="column">
          <h3 style={{ textAlign: 'center' }}>DOCUMENTI OPZIONALI</h3>

          {/* Parte di documenti */}
          <Stack direction="row" gap={4}>

            {/* Checklist dei documenti */}
            <List>
              {documentiOpzionali.map((documentoOpzionale, index) => <ListItem
                key={documentoOpzionale.nomeDocumento}
                disablePadding
              >
                <ListItemButton
                  role={undefined}
                  disabled={!documentoOpzionale.deletable}
                  onClick={() => { handleCheck(index) }} dense>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={documentoOpzionale.isChecked}
                      disabled={!documentoOpzionale.deletable}
                      tabIndex={-1}
                      disableRipple
                      onClick={() => { handleCheck(index) }}
                    />
                  </ListItemIcon>
                  <ListItemText id={"labelId"} primary={documentoOpzionale.nomeDocumento} />
                </ListItemButton>
              </ListItem>)}

            </List>

            {/* Text per motivazione */}
            <Stack direction="column" gap={1} mt={2}>
              <span style={{ fontWeight: '700' }}>Motivazione*</span>
              <Textarea aria-label="minimum height" minRows={3} value={motivazione} onChange={(e) => setMotivazione(e.target.value)} />
            </Stack>
          </Stack>

          {/* Parte di bottoni */}
          <Stack direction="row" gap={2} mt={4}>
            <StyledButton
              onClick={handleRichiesta}
              sx={{ borderRadius: '5px' }}
              disabled={!motivazione || motivazione === ""}
            >
              Richiedi
            </StyledButton>
            <StyledButton
              onClick={handleCloseModalDocumentiOpzionali}
              sx={{
                backgroundColor: theme.palette.grey.light,
                color: theme.palette.black.main,
                border: '0px',
                borderRadius: '5px'
              }}
            >
              <Typography variant="caption">Chiudi</Typography>
            </StyledButton>
          </Stack>
        </Stack>
      </Box>
      <CustomModal
        open={openCustomModal}
        loading={isLoadingCustomModal}
        error={isErrorCustomModal}
        message={messageCustomModal}
      />
    </>
  </Modal>
}

export default DocumentiOpzionaliModal;